class RMErrorType {
    static recordDoesNotExist = new RMErrorType('recordDoesNotExist');
    static noVolumesForSelectedPeriod = new RMErrorType('noVolumesForSelectedPeriod');
    static noRicForSelectedStateUtilityProduct = new RMErrorType('noRicForSelectedStateUtilityProduct');
    static invalidLockedVolume = new RMErrorType('invalidLockedVolume');
    static invalidPrice = new RMErrorType('invalidPrice');
    static tradePeriodPassed = new RMErrorType('tradePeriodPassed');
    static default = new RMErrorType('default');

    constructor(name) {
        this.name = name;
    }

    toString() {
        return `RMErrorType.${this.name}`
    }
}

export default RMErrorType;